import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.veranstaltung-pruefbericht-data';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenVeranstaltungPruefberichtDataEffects {

    VeranstaltungPruefberichtData$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_VERANSTALTUNG_PRUEFBERICHT_DATA),
        mergeMap((x: ac.GetVeranstaltungPruefberichtDataAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getVeranstaltungPruefberichtData(x.veranstaltung_id).pipe(
                map((result: any) => {
                    return new ac.GetVeranstaltungPruefberichtDataErfolgreichAction(result, x.veranstaltung_id, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetVeranstaltungPruefberichtDataFehlerAction(error, x.veranstaltung_id, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.VeranstaltungenQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.VeranstaltungenQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.VeranstaltungenQueryService);
        }
        return this.service;
    }
}
